// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "core-js/es6/promise";
import "core-js/es6/string";
import "core-js/es7/array";
import "normalize.css/normalize.css";
// import 'roboto-fontface/css/roboto/roboto-fontface.css';
// import cssVars from 'css-vars-ponyfill'
import Vue from "vue";
import vuetify from "./plugins/vuetify";
import { i18n, loadLanguageAsync } from "./locale"; // Internationalization

import App from "./App";
import VueGtm from "@gtm-support/vue2-gtm";
import VueMeta from "vue-meta";
import router from "./router";
import "./router/permission"; // permission control
import store from "./store";

import permission from "@/directives/permission"; // 權限判斷
import Vuelidate from "vuelidate";
import {
  redirectWithLine,
  redirectWithAndroidFb
} from "./shared/webViewRedirect";
// Prevent webview browser

redirectWithLine();
redirectWithAndroidFb();

Vue.use(Vuelidate);
Vue.use(VueMeta);
Vue.use(permission);

Vue.use(VueGtm, {
  id: process.env.VUE_APP_GTM_KEY,
  defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
  compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
  // nonce: '2726c7f26c', // Will add `nonce` to the script tag
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: false, // Whether or not display console logs debugs (optional)
  loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  // ignoredViews: ['homepage'], // Don't trigger events for specified router names (optional)
  trackOnNextTick: false // Whether or not call trackView in Vue.nextTick
});

import * as filters from "./filters"; // global filters
// register global utility filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

// 其他套件
import "./vendor";

const requireComponents = require.context("../src/components", true, /\.vue$/);
requireComponents.keys().forEach(fileName => {
  const componentConfig = requireComponents(fileName);
  const componentName = fileName.replace(/^\.\//, "").replace(/\.\w+$/, "");
  Vue.component(componentName, componentConfig.default || componentConfig);
});

router.beforeResolve((to, from, next) => {
  // const lang = to.params.lang
  loadLanguageAsync().then(() => next());
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  i18n,
  router,
  store,
  template: "<App/>",
  vuetify,
  components: {
    App
  },

  render: h => h(App)
});

window.onload = () => {
  document.addEventListener(
    "touchstart",
    event => {
      if (event.touches.length > 1) {
        event.preventDefault();
      }
    },
    { passive: false }
  );

  let lastTouchEnd = 0;
  document.addEventListener(
    "touchend",
    event => {
      const now = new Date().getTime();
      if (now - lastTouchEnd <= 300) {
        event.preventDefault();
      }
      lastTouchEnd = now;
    },
    false
  );
};
